import type { AuthResponse, AuthResponseData, AuthResponseMeta } from '@/types/auth';

const readString = (value: unknown): string | undefined => {
  if (typeof value !== 'string') {
    return undefined;
  }

  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

type SigninRedirectPayload =
  | AuthResponse
  | AuthResponseData
  | { meta?: AuthResponseMeta | undefined }
  | undefined
  | null;

function extractMeta(payload: SigninRedirectPayload): AuthResponseMeta | undefined {
  if (!payload || typeof payload !== 'object') {
    return undefined;
  }

  if ('data' in payload && payload.data) {
    const record = payload as AuthResponse;
    const nestedMeta =
      (record.data?.meta as AuthResponseMeta | undefined) ??
      (record.meta as AuthResponseMeta | undefined);
    if (nestedMeta) {
      return nestedMeta;
    }
  }

  if ('meta' in payload) {
    return (payload as AuthResponseData).meta as AuthResponseMeta | undefined;
  }

  return undefined;
}

export function resolveSigninRedirectUrl(
  payload: SigninRedirectPayload,
): string | null {
  const meta = extractMeta(payload);
  if (!meta) {
    return null;
  }

  const url =
    readString((meta as { signin_redirect_url?: unknown }).signin_redirect_url) ??
    readString((meta as { signinRedirectUrl?: unknown }).signinRedirectUrl);

  return url ?? null;
}
